  import React, { useState, useEffect } from "react";
  import {  useNavigate } from "react-router-dom";
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    
    // Redirect logged-in users away from the login page
      useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
          navigate("/dashboard");
        }
      }, [navigate]);

      const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
      
        try {
          const response = await fetch(`${baseUrl}/auth/login`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ email, password })
          });
      
          const result = await response.json();
      
          if (!response.ok) {
            throw new Error(result?.message);
          }
      
          if (result?.status === true && result?.data.token) {
            localStorage.setItem("token", result.data.token);
            alert("Login successful");
            console.log(result.message);
            navigate("/dashboard");
          } else {
            throw new Error(result?.message);
          }
        } catch (err) {
          console.error("Login Error:", err);
          setError(err.message || "Something went wrong. Please try again.");
        }
      
        setLoading(false);
      };
      
      
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-lg border border-gray-200 w-96">
          <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">Admin Login</h2>
          {error && <p className="text-red-500 text-sm text-center">{error}</p>}
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="text-gray-700 block text-sm">Email</label>
              <input
                type="email"
                className="w-full px-3 py-2 mt-1 text-gray-900 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="text-gray-700 block text-sm">Password</label>
              <input
                type="password"
                className="w-full px-3 py-2 mt-1 mb-2 text-gray-900 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-md text-lg font-semibold transition"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    );
  };

  export default Login;